import * as React from "react";
function SvgSinaweibo(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M21.26 7.06a6.4 6.4 0 00-1.26.13.84.84 0 00.35 1.65 4.12 4.12 0 014.81 5.32.85.85 0 001.61.52 5.83 5.83 0 00-5.46-7.62zm-7.11 2.55c-1.55 0-3.84 1.24-5.87 3.28S5 17.16 5 19.06c0 3.64 4.67 5.88 9.23 5.88 6 0 10-3.48 10-6.24a3.31 3.31 0 00-2.67-3c-.31-.1-.52-.16-.37-.56a2.27 2.27 0 000-2.2c-.68-1-2.66-1-4.9 0 0 0-.69.31-.53-.24a2.51 2.51 0 00-.24-2.57 1.77 1.77 0 00-1.37-.46zm7.07.47a3.39 3.39 0 00-.64.06.73.73 0 00-.53.49.72.72 0 00.15.71.73.73 0 00.69.22 1.37 1.37 0 011.32.42 1.38 1.38 0 01.29 1.36.73.73 0 001.37.45 2.85 2.85 0 00-.39-2.53 2.81 2.81 0 00-2.26-1.18zm-6.82 4.81c3.19 0 5.8 1.56 6 3.73.24 2.39-2.53 4.62-6.19 5s-6.77-1.28-7-3.67 2.52-4.62 6.19-5h1zm-.79 1.8a3.93 3.93 0 00-3.43 2.06 2.71 2.71 0 001.69 3.83 3.94 3.94 0 004.7-2 2.75 2.75 0 00-2-3.8 3.81 3.81 0 00-.96-.09zm-1.19 2.54a1.13 1.13 0 01.45.09 1 1 0 01.53.63 1 1 0 01-.15.81 1.37 1.37 0 01-1.68.55 1 1 0 01-.53-.64 1 1 0 01.16-.81 1.41 1.41 0 011.2-.65z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSinaweibo);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
